import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { updateEmployeeLeaveAllocation, 
  // fetchEmployeeLeavesByEmployeeId
 } from '../../../store/slices/LeaveManagement/employeeLeaveSlice';

// Added onSuccess prop to trigger re-fetch in parent
const AllocateLeaveModal = ({ isOpen, onClose, leaveData, onSuccess }) => {
  const dispatch = useDispatch();
  const [newAllocation, setNewAllocation] = useState(0);
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    if (isOpen && leaveData) {
      setNewAllocation(parseFloat(leaveData.allocated) || 0);
    }
  }, [isOpen, leaveData]);

  if (!isOpen) return null;

  const handleSave = async () => {
    setIsSaving(true);
    try {
      await dispatch(updateEmployeeLeaveAllocation({
        employeeId: leaveData.employeeId,
        leaveTypeId: leaveData.leaveTypeId,
        year: leaveData.year,
        allocatedDays: newAllocation
      })).unwrap();
      
      // Success alert
      alert("Leave allocation updated successfully!");
// dispatch(fetchEmployeeLeavesByEmployeeId({ 
//   id: leaveData.employeeId, 
//   year: leaveData.year 
// }));
      // Trigger parent refresh
      if (onSuccess) onSuccess(); 
      
      onClose();
    } catch (err) {
      console.error("Failed to update allocation:", err);
      alert("Error: " + (err || "Could not update allocation"));
    } finally {
      setIsSaving(false);
    }
  };

  return (
    // ... (rest of your modal JSX remains the same)
    <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Allocate {leaveData?.leaveType?.name}</h5>
            <button type="button" className="btn-close" onClick={onClose} disabled={isSaving}></button>
          </div>
          <div className="modal-body">
            <div className="mb-3">
              <label className="form-label fw-bold">New Allocation Amount</label>
              <input 
                type="number" 
                className="form-control"
                value={newAllocation}
                onChange={(e) => setNewAllocation(parseFloat(e.target.value))}
                disabled={isSaving}
              />
            </div>
            <p className="text-muted small">Current Balance: {leaveData?.allocated}</p>
          </div>
          <div className="modal-footer">
            <button className="btn btn-secondary" onClick={onClose} disabled={isSaving}>Close</button>
            <button className="btn btn-primary" onClick={handleSave} disabled={isSaving}>
              {isSaving ? 'Saving...' : 'Save Changes'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllocateLeaveModal;